import { selectCountries } from 'legacy/lut/selectors/app'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import { search } from '../../../services/search_v2'
import { REQUEST_MORE_PARTNERS } from '../constants'
import { selectPartnerSearchFilters } from '../selectors'

export const requestMorePartners = createAsyncThunk(
  REQUEST_MORE_PARTNERS,
  async (_, { getState }) => {
    const state = getState()

    const countries = selectCountries(state)
    const user = selectUser(state)
    const filters = selectPartnerSearchFilters(state)

    const response = await search({ filters, user, countries }, 'partners')

    return response.data.items ?? []
  }
)
